import { Subject } from "rxjs";

/**
 * One place for "the request failed" to become something the user can see.
 *
 * The API layer used to answer a failed request with `undefined` and pop a
 * native `alert()`, while the 42 per-service `handleErrorResponse()` helpers
 * were empty functions called from 95 sites. So a failure showed a blocking
 * browser dialog with a generic string and then nothing changed on screen.
 *
 * `webApiService` now publishes the real status and the server's own message
 * here, and `ApiErrorToaster` (mounted once, inside the ToastProvider) turns
 * that into a toast. Services stay free of React, and no screen has to
 * remember to report an error it did not expect.
 */
export interface ApiErrorEvent {
  message: string;
  status?: number;
}

const apiErrors = new Subject<ApiErrorEvent>();

const notifyApiError = (event: ApiErrorEvent) => {
  apiErrors.next(event);
};

export const apiErrorNotifier = {
  apiErrors,
  notifyApiError,
};
